// SILKhee Hero Grid — extracted from silkhee_grid_15.html prototype
// Animated color blob grid for landing/hero sections

(function () {
  const canvas = document.getElementById('cs-hero-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');

  let W, H, raf, cells = [];
  let startTime = null;

  // ── External color override API ──────────────────────────────────
  // External callers set overrides by "row-col_idx" key → {h,s,l,vivid}
  let externalOverrides = {};
  window.silkheeGridSetOverrides = function(map) {
    externalOverrides = map || {};
  };

  // ── HELPERS ────────────────────────────────────────────────────
  function clamp(v,a,b) { return Math.max(a,Math.min(b,v)); }
  function eo3(t)       { return 1-Math.pow(1-t,3); }
  function eo4(t)       { return 1-Math.pow(1-t,4); }
  function lerp(a,b,t)  { return a+(b-a)*t; }
  function smootherstep(t) { return t*t*t*(t*(t*6-15)+10); }

  // ── PERLIN NOISE ───────────────────────────────────────────────
  const perm = new Uint8Array(512);
  (function(){
    const p=[];
    for(let i=0;i<256;i++) p[i]=i;
    for(let i=255;i>0;i--){const j=Math.floor(Math.random()*(i+1));[p[i],p[j]]=[p[j],p[i]];}
    for(let i=0;i<512;i++) perm[i]=p[i&255];
  })();
  function fade(t){return t*t*t*(t*(t*6-15)+10);}
  function glrp(a,b,t){return a+(b-a)*t;}
  function grad2(h,x,y){const v=h&1?x:y;return h&2?-v:v;}
  function noise2(x,y){
    const X=Math.floor(x)&255,Y=Math.floor(y)&255,xf=x-Math.floor(x),yf=y-Math.floor(y);
    const u=fade(xf),v=fade(yf),A=perm[X]+Y,B=perm[X+1]+Y;
    return glrp(glrp(grad2(perm[A],xf,yf),grad2(perm[B],xf-1,yf),u),glrp(grad2(perm[A+1],xf,yf-1),grad2(perm[B+1],xf-1,yf-1),u),v);
  }

  function seededRand(seed) {
    let s = seed;
    return () => { s=(s*1664525+1013904223)&0xffffffff; return (s>>>0)/0xffffffff; };
  }

  function rrectPath(x,y,w,h,r) {
    ctx.beginPath();
    ctx.moveTo(x+r,y); ctx.arcTo(x+w,y,x+w,y+h,r);
    ctx.arcTo(x+w,y+h,x,y+h,r); ctx.arcTo(x,y+h,x,y,r);
    ctx.arcTo(x,y,x+w,y,r); ctx.closePath();
  }

  // ── BUILD GRID ─────────────────────────────────────────────────
  function buildGrid(COLORS) {
    cells = [];
    const COLS = 8, GAP = 4;
    const cw   = (W + GAP) / COLS - GAP;
    const ch   = cw * 0.88;
    const ROWS  = Math.ceil((H + GAP) / (ch + GAP));
    const rad  = cw * 0.12;
    const rng  = seededRand(42);

    const colorSeq = [];
    for (let i = 0; i < COLS * ROWS; i++) colorSeq.push(i % COLORS.length);
    for (let i = colorSeq.length - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i+1));
      [colorSeq[i],colorSeq[j]] = [colorSeq[j],colorSeq[i]];
    }

    for (let r = 0; r < ROWS; r++) {
      for (let c = 0; c < COLS; c++) {
        const i    = r * COLS + c;
        const col  = COLORS[colorSeq[i % colorSeq.length]];
        const rng2 = seededRand(i * 997 + 13);
        const restingL    = 88 + rng2() * 6;
        const restingTint = rng2() * 8;
        cells.push({
          x: c*(cw+GAP), y: r*(ch+GAP), w:cw, h:ch, rad, col,
          row: r, col_idx: c,
          ox: (rng2()-0.5)*cw*0.13, oy: (rng2()-0.5)*ch*0.11-ch*0.02,
          sqX: 0.86+rng2()*0.18, sqY: 0.70+rng2()*0.20,
          baseViv: col.vivid*(0.65+rng2()*0.35),
          driftX: cw*0.042, driftY: ch*0.036,
          p1: rng2()*Math.PI*2, p2: rng2()*Math.PI*2, p3: rng2()*Math.PI*2,
          s1: 0.10+rng2()*0.12, s2: 0.07+rng2()*0.09, s3: 0.05+rng2()*0.08,
          restingL, restingTint,
          restElev:   rng2()*0.4,
          restShadow: 0.15+rng2()*0.18,
          restGloss:  0.06+rng2()*0.10,
          gx: (c+0.5)/COLS, gy: (r+0.5)/ROWS,
          enterDelay: Math.sqrt(Math.pow(c/COLS-0.5,2)+Math.pow(r/ROWS-0.5,2))*1.2+rng2()*0.2,
          alpha:0, intensity:0, curOx:0, curOy:0, light:0, elevation:0,
          // Palette transition
          polyCol: {...col}, fromCol: {...col}, targetCol: {...col}, transitionStart: null,
        });
      }
    }
  }

  // ── DRAW CELL ──────────────────────────────────────────────────
  function drawCell(cell, t, lx, ly, blobOffsetY) {
    const { x,y,w,h,rad,col,sqX,sqY,curOx,curOy,alpha,intensity,gx,gy,
            restingL,restingTint,restElev,restShadow,restGloss } = cell;
    if (alpha < 0.005) return;

    const dist  = Math.sqrt(Math.pow(gx-lx,2)+Math.pow(gy-ly,2));
    const light = smootherstep(clamp(1-dist*2.1,0,1));
    cell.light  = light;

    const noiseElev = noise2(gx*3.0+t*0.032, gy*3.0+t*0.028)*0.5+0.5;
    const unlitElev = noiseElev*0.35+restElev*0.25;
    const elevation = lerp(unlitElev, 0.85+noiseElev*0.15, light);
    cell.elevation  = elevation;

    const expand = elevation * 3.8;
    const xe=x-expand,ye=y-expand,we=w+expand*2,he=h+expand*2,re=rad+expand*0.4;
    const surfL  = lerp(restingL, 98, light);
    const cx     = x+w/2+curOx;
    const cy     = y+h/2+curOy;
    // Blob center: overridden cells stay fixed at cy; ambient cells shift up with scroll
    const bcy    = cy + (externalOverrides[cell.row + '-' + cell.col_idx] ? 0 : (blobOffsetY || 0));

    const blobScale = lerp(1.0,1.40,light);
    const satBoost  = lerp(1.0,1.26,light);
    const alpBoost  = lerp(1.0,1.22,light);
    const bS        = Math.min(100, col.s*satBoost);

    // Overridden cells use tighter blob sizing so glow stays within cell boundaries
    const isOverridden  = !!externalOverrides[cell.row + '-' + cell.col_idx];
    const drawSqX       = isOverridden ? 0.85 : sqX;
    const drawSqY       = isOverridden ? 0.72 : sqY;
    const drawIntensity = isOverridden ? 0.85 : intensity;

    // ── PASS 1: tile background + surface shading, clipped ─────────
    ctx.save();
    ctx.globalAlpha = alpha;

    // Surface fill
    ctx.fillStyle = `hsl(${34+restingTint},${9+restingTint*0.5}%,${Math.round(surfL)}%)`;
    ctx.beginPath();
    ctx.moveTo(xe+re,ye); ctx.arcTo(xe+we,ye,xe+we,ye+he,re);
    ctx.arcTo(xe+we,ye+he,xe,ye+he,re); ctx.arcTo(xe,ye+he,xe,ye,re);
    ctx.arcTo(xe,ye,xe+we,ye,re); ctx.closePath(); ctx.fill();

    // Clip to tile
    ctx.beginPath();
    ctx.moveTo(xe+re,ye); ctx.arcTo(xe+we,ye,xe+we,ye+he,re);
    ctx.arcTo(xe+we,ye+he,xe,ye+he,re); ctx.arcTo(xe,ye+he,xe,ye,re);
    ctx.arcTo(xe,ye,xe+we,ye,re); ctx.closePath(); ctx.clip();

    // Directional shading
    const la  = Math.atan2(ly-gy, lx-gx);
    const ccx = xe+we/2, ccy = ye+he/2;
    const sg  = ctx.createLinearGradient(
      ccx-Math.cos(la)*we*0.65, ccy-Math.sin(la)*he*0.65,
      ccx+Math.cos(la)*we*0.65, ccy+Math.sin(la)*he*0.65
    );
    sg.addColorStop(0,   `rgba(255,255,255,${light*0.35+0.04})`);
    sg.addColorStop(0.4, 'rgba(255,255,255,0)');
    sg.addColorStop(0.6, 'rgba(0,0,0,0)');
    sg.addColorStop(1,   `rgba(0,0,0,${(1-light)*0.13+0.01})`);
    ctx.fillStyle=sg; ctx.fillRect(xe,ye,we,he);

    // Crease shadows
    const cs = lerp(restShadow, 0.05, light);
    const ctg = ctx.createLinearGradient(xe,ye,xe,ye+he*0.09);
    ctg.addColorStop(0,`rgba(0,0,0,${cs})`); ctg.addColorStop(1,'rgba(0,0,0,0)');
    ctx.fillStyle=ctg; ctx.fillRect(xe,ye,we,he*0.09);

    const clg = ctx.createLinearGradient(xe,ye,xe+we*0.08,ye);
    clg.addColorStop(0,`rgba(0,0,0,${cs*0.75})`); clg.addColorStop(1,'rgba(0,0,0,0)');
    ctx.fillStyle=clg; ctx.fillRect(xe,ye,we*0.08,he);

    const cbg = ctx.createLinearGradient(xe,ye+he,xe,ye+he-he*0.07);
    cbg.addColorStop(0,`rgba(0,0,0,${cs*0.52})`); cbg.addColorStop(1,'rgba(0,0,0,0)');
    ctx.fillStyle=cbg; ctx.fillRect(xe,ye+he-he*0.07,we,he*0.07);

    const crg = ctx.createLinearGradient(xe+we,ye,xe+we-we*0.07,ye);
    crg.addColorStop(0,`rgba(0,0,0,${cs*0.42})`); crg.addColorStop(1,'rgba(0,0,0,0)');
    ctx.fillStyle=crg; ctx.fillRect(xe+we-we*0.07,ye,we*0.07,he);

    // Gloss
    const gs = lerp(restGloss, 0.60, light);
    const gh = lerp(0.22, 0.38, light);
    const gg = ctx.createLinearGradient(xe,ye,xe,ye+he*gh);
    gg.addColorStop(0,    `rgba(255,255,255,${gs})`);
    gg.addColorStop(0.38, `rgba(255,255,255,${gs*0.20})`);
    gg.addColorStop(1,    'rgba(255,255,255,0)');
    ctx.fillStyle=gg; ctx.fillRect(xe,ye,we,he*gh);

    if (light > 0.30) {
      const lb = ctx.createRadialGradient(ccx,ccy,0,ccx,ccy,Math.max(we,he)*0.65);
      lb.addColorStop(0,   `rgba(255,255,255,${light*0.16})`);
      lb.addColorStop(0.5, `rgba(255,255,255,${light*0.06})`);
      lb.addColorStop(1,   'rgba(255,255,255,0)');
      ctx.fillStyle=lb; ctx.fillRect(xe,ye,we,he);
    }

    ctx.restore(); // releases clip

    // ── PASS 2: blob layers — NO clip, bleed freely beyond tile ────
    if (drawIntensity > 0.01) {
      ctx.save();
      ctx.globalAlpha = alpha;

      // Color blob core — radius ×1.2 vs original
      const coreRadiusMult = isOverridden ? 0.24 : 0.31;
      const coreR = Math.min(w,h)*coreRadiusMult*drawIntensity*blobScale;
      if (coreR > 0.5) {
        const gc = ctx.createRadialGradient(cx,bcy,0,cx,bcy,coreR);
        gc.addColorStop(0,   `hsla(${col.h},${bS}%,${Math.max(col.l-20,18)}%,${0.96*drawIntensity*alpBoost})`);
        gc.addColorStop(0.45,`hsla(${col.h},${bS}%,${col.l-10}%,${0.70*drawIntensity*alpBoost})`);
        gc.addColorStop(1,   `hsla(${col.h},${bS}%,${col.l+4}%,0)`);
        ctx.fillStyle=gc; ctx.fillRect(cx-coreR,bcy-coreR,coreR*2,coreR*2);
      }

      // Mid bloom — radius ×1.2 vs original
      const blobWMult = isOverridden ? 0.74 : 0.94;
      const blobHMult = isOverridden ? 0.66 : 0.84;
      const mw = w*blobWMult*drawSqX*drawIntensity*blobScale;
      const mh = h*blobHMult*drawSqY*drawIntensity*blobScale;
      if (mw > 0.5) {
        ctx.save();
        ctx.translate(cx,bcy); ctx.scale(1,mh/Math.max(mw,0.001)); ctx.translate(-cx,-bcy);
        const gm = ctx.createRadialGradient(cx,bcy,0,cx,bcy,mw);
        gm.addColorStop(0,   `hsla(${col.h},${bS}%,${col.l}%,${0.76*drawIntensity*alpBoost})`);
        gm.addColorStop(0.25,`hsla(${col.h},${bS*0.9}%,${col.l+6}%,${0.48*drawIntensity*alpBoost})`);
        gm.addColorStop(0.52,`hsla(${col.h},${bS*0.65}%,${col.l+14}%,${0.22*drawIntensity})`);
        gm.addColorStop(0.78,`hsla(${col.h},${bS*0.35}%,${col.l+22}%,${0.08*drawIntensity})`);
        gm.addColorStop(1,   'rgba(230,226,219,0)');
        ctx.fillStyle=gm; ctx.fillRect(cx-mw,bcy-mw,mw*2,mw*2);
        ctx.restore();
      }

      // Atmosphere — radius ×1.2 vs original
      const ar = Math.max(w,h)*1.08*blobScale;
      const atmInner = mw > 0 ? mw*0.25 : 0;
      const ga = ctx.createRadialGradient(cx,bcy,atmInner,cx,bcy,ar);
      ga.addColorStop(0,  `hsla(${col.h},${bS*0.30}%,${col.l+18}%,${0.10*drawIntensity*alpBoost})`);
      ga.addColorStop(0.6,`hsla(${col.h},${bS*0.15}%,${col.l+24}%,${0.04*drawIntensity})`);
      ga.addColorStop(1,  'rgba(230,226,219,0)');
      ctx.fillStyle=ga; ctx.fillRect(cx-ar,bcy-ar,ar*2,ar*2);

      ctx.restore();
    }

    // ── Border ──────────────────────────────────────────────────────
    ctx.save();
    ctx.globalAlpha = alpha * lerp(0.04,0.20,1-light) * lerp(0.5,1,restShadow/0.33);
    ctx.strokeStyle = 'rgba(0,0,0,0.55)';
    ctx.lineWidth   = 0.7;
    rrectPath(x+0.35,y+0.35,w-0.7,h-0.7,rad);
    ctx.stroke();
    ctx.restore();
  }

  // ── COLOR CONVERSION ───────────────────────────────────────────
  function hexToHsl(hex) {
    const r = parseInt(hex.slice(1,3),16)/255;
    const g = parseInt(hex.slice(3,5),16)/255;
    const b = parseInt(hex.slice(5,7),16)/255;
    const max=Math.max(r,g,b),min=Math.min(r,g,b);
    let h,s,l=(max+min)/2;
    if(max===min){h=s=0;}
    else{
      const d=max-min;
      s=l>0.5?d/(2-max-min):d/(max+min);
      switch(max){case r:h=(g-b)/d+(g<b?6:0);break;case g:h=(b-r)/d+2;break;default:h=(r-g)/d+4;}
      h/=6;
    }
    return { h: Math.round(h*360), s: Math.round(s*100), l: Math.round(l*100), vivid: s };
  }

  // ── RESIZE ─────────────────────────────────────────────────────
  function resize() {
    W = canvas.width  = window.innerWidth;
    H = canvas.height = window.innerHeight;
  }

  // ── INIT ───────────────────────────────────────────────────────
  function init() {
    // Pin canvas to viewport so it stays fixed as page scrolls
    canvas.style.position      = 'fixed';
    canvas.style.top           = '0';
    canvas.style.left          = '0';
    canvas.style.width         = '100vw';
    canvas.style.height        = '100vh';
    canvas.style.zIndex        = '0';
    canvas.style.pointerEvents = 'none';
    if (canvas.parentElement) canvas.parentElement.style.background = 'transparent';

    resize();

    // Fixed color palette from prototype — diverse hues across the wheel
    const colors = [
      {h:42,s:92,l:52,vivid:0.95},{h:22,s:88,l:48,vivid:0.90},{h:8,s:80,l:44,vivid:0.85},
      {h:355,s:75,l:50,vivid:0.88},{h:50,s:85,l:58,vivid:0.82},{h:28,s:60,l:55,vivid:0.65},
      {h:15,s:50,l:52,vivid:0.60},{h:345,s:45,l:60,vivid:0.55},{h:205,s:82,l:46,vivid:0.90},
      {h:175,s:78,l:38,vivid:0.88},{h:255,s:72,l:50,vivid:0.85},{h:160,s:70,l:38,vivid:0.82},
      {h:330,s:80,l:48,vivid:0.88},{h:220,s:58,l:52,vivid:0.70},{h:185,s:48,l:50,vivid:0.62},
      {h:265,s:45,l:55,vivid:0.65},{h:155,s:40,l:52,vivid:0.58},{h:240,s:35,l:60,vivid:0.52},
      {h:35,s:25,l:65,vivid:0.35},{h:200,s:20,l:62,vivid:0.30},{h:120,s:22,l:60,vivid:0.32},
      {h:310,s:55,l:52,vivid:0.78},{h:135,s:65,l:40,vivid:0.80},{h:195,s:85,l:42,vivid:0.92},
      {h:275,s:65,l:48,vivid:0.80},{h:88,s:60,l:44,vivid:0.78},
    ];

    buildGrid(colors);
    startTime = null;

    if (raf) cancelAnimationFrame(raf);

    function frame(now) {
      if (!startTime) startTime = now;
      const el = (now - startTime) / 1000;
      const t  = el;

      const lx = 0.5 + Math.sin(t*0.10)*0.34 + Math.sin(t*0.067+1.0)*0.12;
      const ly = 0.40 + Math.cos(t*0.085)*0.28 + Math.cos(t*0.12+0.6)*0.10;

      ctx.fillStyle = 'hsl(34,8%,83%)';
      ctx.fillRect(0,0,W,H);

      const bgl = ctx.createRadialGradient(lx*W,ly*H,0,lx*W,ly*H,Math.max(W,H)*0.52);
      bgl.addColorStop(0,   'rgba(255,252,246,0.30)');
      bgl.addColorStop(0.5, 'rgba(248,244,238,0.10)');
      bgl.addColorStop(1,   'rgba(0,0,0,0)');
      ctx.fillStyle=bgl; ctx.fillRect(0,0,W,H);

      // blobOffsetY removed — canvas is now a fixed background across all 3 sections;
      // a scroll-based offset pushed blob centers off-canvas when past the first section
      const blobOffsetY = 0;

      cells.forEach(cell => {
        const ep = clamp((el-cell.enterDelay)/1.7,0,1);
        cell.alpha = eo4(ep);
        cell.curOx = cell.ox + Math.sin(t*cell.s1+cell.p1)*cell.driftX + Math.cos(t*cell.s1*0.7+cell.p2)*cell.driftX*0.4;
        cell.curOy = cell.oy + Math.cos(t*cell.s1+cell.p2)*cell.driftY + Math.sin(t*cell.s1*0.6+cell.p3)*cell.driftY*0.4;
        const breathe = 0.90 + Math.sin(t*cell.s2+cell.p2)*0.10 + Math.sin(t*cell.s3+cell.p3)*0.05;
        cell.intensity = eo3(clamp((el-cell.enterDelay-0.1)/2.2,0,1)) * cell.baseViv * breathe;
        // Palette color transition
        if (cell.transitionStart !== null) {
          const tp = Math.min((performance.now() - cell.transitionStart) / (cell.transitionDuration || 600), 1);
          const eased = tp*tp*(3-2*tp);
          cell.col = {
            h:     lerp(cell.fromCol.h,     cell.targetCol.h,     eased),
            s:     lerp(cell.fromCol.s,     cell.targetCol.s,     eased),
            l:     lerp(cell.fromCol.l,     cell.targetCol.l,     eased),
            vivid: lerp(cell.fromCol.vivid, cell.targetCol.vivid, eased),
          };
          if (tp >= 1) { cell.col = {...cell.targetCol}; cell.transitionStart = null; }
        }
      });

      // Apply / restore external color overrides before drawing
      cells.forEach(cell => {
        const key = cell.row + '-' + cell.col_idx;
        if (externalOverrides[key]) {
          cell._originalCol = cell._originalCol || cell.col;
          cell.col = externalOverrides[key];
        } else if (cell._originalCol) {
          cell.col = cell._originalCol;
          cell._originalCol = null;
        }
      });

      cells.forEach(cell => { if (cell.alpha > 0.005) drawCell(cell,t,lx,ly,blobOffsetY); });
      raf = requestAnimationFrame(frame);
    }

    raf = requestAnimationFrame(frame);
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 150);
  });

  // ── PALETTE TRANSITION API ─────────────────────────────────────
  // Accepts array of hex strings; transitions all cell blob colors over durationMs
  window.silkheeGridSetPalette = function(hexColors, durationMs) {
    if (!cells.length) return;
    const hslColors = hexColors.map(hexToHsl);
    const now = performance.now();
    cells.forEach((cell, i) => {
      const target = hslColors[i % hslColors.length];
      cell.fromCol = {...cell.col};
      cell.targetCol = {...target};
      cell.transitionStart = now;
      cell.transitionDuration = durationMs || 600;
    });
  };

  // ── SCROLL ZONE — shift blob palette per section ───────────────
  // POLY (section 1): default pastel palette
  // METALLIC (section 2): warm gold range
  // MATTE (section 3): cool baby blue range
  // Metallic: alternates gold ↔ silver for shimmer contrast
  const METALLIC_PALETTE = [
    '#d4a838',  // warm gold
    '#c8c8c8',  // bright silver
    '#b89968',  // antique gold
    '#e0dcd4',  // soft pearl silver
    '#a8842c',  // deep bronze
    '#a8a4a0',  // medium silver
    '#c4a674',  // pale gold
    '#d8d6d2',  // light silver
  ];
  // Matte: blues mixed with warm neutrals for tonal gradient / watercolor feel
  const MATTE_PALETTE = [
    '#c8dff0',  // pale baby blue
    '#e8e4dc',  // soft cream
    '#a8c8dc',  // mid blue
    '#d4dcd8',  // pale sage-cream
    '#bcd0e0',  // soft sky
    '#c0c4c8',  // soft grey
    '#b4d4e8',  // baby sky
    '#dce0dc',  // pale neutral
  ];

  let currentZone = 'poly';

  function restorePolyPalette() {
    if (!cells.length) return;
    const now = performance.now();
    cells.forEach(cell => {
      cell.fromCol = {...cell.col};
      cell.targetCol = {...cell.polyCol};
      cell.transitionStart = now;
      cell.transitionDuration = 600;
    });
  }

  function onScrollZoneCheck() {
    const scrollY = window.scrollY;
    const vh = window.innerHeight;
    let zone;
    if (scrollY < vh * 0.8)       zone = 'poly';
    else if (scrollY < vh * 1.8)  zone = 'metallic';
    else                           zone = 'matte';

    if (zone === currentZone) return;
    currentZone = zone;
    if (zone === 'metallic')       window.silkheeGridSetPalette(METALLIC_PALETTE, 600);
    else if (zone === 'matte')     window.silkheeGridSetPalette(MATTE_PALETTE, 600);
    else                           restorePolyPalette();
  }

  window.addEventListener('scroll', onScrollZoneCheck, { passive: true });

  init();

})();
